import React from 'react';
import { MoreVertical, Plus, Share, Smartphone } from 'lucide-react';
import { Card } from './ui';

export const PWAInstallAdvice: React.FC = () => {
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !(window as any).MSStream;
    const isAndroid = /Android/.test(navigator.userAgent);
    const isTelegram = !!(window as any).Telegram?.WebApp;

    // Detect if running in standalone mode (installed as PWA)
    const isStandalone = (typeof window.matchMedia === 'function' && window.matchMedia('(display-mode: standalone)').matches)
        || (navigator as any).standalone
        || document.referrer.includes('android-app://');

    // Only show on mobile devices and only if NOT already installed/standalone
    if ((!isIOS && !isAndroid) || isStandalone || isTelegram) return null;

    return (
        <Card padding="none" className="mb-6 overflow-hidden">
            <div className="flex flex-col sm:flex-row">
                <div className="flex flex-col items-center justify-center gap-2 bg-brand p-6 text-center text-on-brand sm:w-1/3">
                    <Smartphone className="h-10 w-10" aria-hidden="true" />
                    <p className="font-display font-semibold">App installieren</p>
                    <p className="text-sm text-on-brand/80">Für Echtzeit-Push am besten als App nutzen</p>
                </div>

                <div className="flex-1 p-6">
                    {isIOS && (
                        <div className="flex flex-col gap-3">
                            <h3 className="text-sm font-semibold text-ink">Anleitung für Safari</h3>
                            <div className="flex items-start gap-3">
                                <Share className="mt-0.5 h-5 w-5 shrink-0 text-brand" aria-hidden="true" />
                                <p className="text-sm text-ink">
                                    1. Tippe unten in der Safari-Leiste auf das <strong>Teilen-Icon</strong>.
                                </p>
                            </div>
                            <div className="flex items-start gap-3">
                                <Plus className="mt-0.5 h-5 w-5 shrink-0 text-brand" aria-hidden="true" />
                                <p className="text-sm text-ink">
                                    2. Scrolle nach unten und wähle <strong>„Zum Home-Bildschirm“</strong>.
                                </p>
                            </div>
                            <p className="rounded-control bg-sunken p-3 text-xs text-muted">
                                Hinweis: Auf iOS funktioniert der Push-Dienst nur, wenn die Seite zum Home-Bildschirm hinzugefügt wurde.
                            </p>
                        </div>
                    )}

                    {isAndroid && (
                        <div className="flex flex-col gap-3">
                            <h3 className="text-sm font-semibold text-ink">Anleitung für Chrome</h3>
                            <div className="flex items-start gap-3">
                                <MoreVertical className="mt-0.5 h-5 w-5 shrink-0 text-brand" aria-hidden="true" />
                                <p className="text-sm text-ink">
                                    1. Tippe oben rechts auf das <strong>Drei-Punkt-Menü</strong>.
                                </p>
                            </div>
                            <div className="flex items-start gap-3">
                                <Share className="mt-0.5 h-5 w-5 shrink-0 text-brand" aria-hidden="true" />
                                <p className="text-sm text-ink">
                                    2. Wähle <strong>„App installieren“</strong> oder <strong>„Zum Startbildschirm hinzufügen“</strong>.
                                </p>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </Card>
    );
};
